import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 600px;
  @media screen and (max-width: 648px) {
    width: 100%;
  }
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`;
